/** The two shapes an expense's project can arrive in. */
export interface ExpenseProjectSource {
  /** Written by every save since the document model; the source of truth. */
  projectName?: string | null;
  /** Legacy row joined off the deprecated projectId, on pre-migration expenses. */
  project?: { name: string | null } | null;
}

/**
 * One rule for "which project is this expense on", used by display, sorting and
 * the edit form so they cannot disagree.
 *
 * Expenses stopped storing a project id when breakdowns moved to the document
 * model: projects live in breakdown_doc_projects, one row per document with
 * fresh ids on every copy, so no id identifies a project at job level. New rows
 * carry the name; older rows still resolve theirs through the legacy relation.
 */
export function expenseProjectName(expense: ExpenseProjectSource): string | null {
  return expense.projectName ?? expense.project?.name ?? null;
}
